import { createContext, useContext } from 'react';
import en from './en';
import de from './de';
import fr from './fr';
import it from './it';
import es from './es';
import nl from './nl';
import pl from './pl';
import type { LangStrings } from './en';

// Bundled statically so that switching languages works offline (chunked
// imports would require a network round-trip the user doesn't have).
const modules: Record<string, LangStrings> = {
  de,
  fr,
  it,
  es,
  nl,
  pl,
};

export type LangCode = 'en' | 'de' | 'fr' | 'it' | 'es' | 'nl' | 'pl';

export interface I18nContextType {
  t: LangStrings;
  lang: LangCode;
  setLang: (code: LangCode) => void;
}

export const I18nContext = createContext<I18nContextType>({
  t: en,
  lang: 'en',
  setLang: () => {},
});

export function useTranslation(): I18nContextType {
  return useContext(I18nContext);
}

export { modules as langModules };
export { en };
export type { LangStrings };
